import React, { useState,useEffect,useCallback,useRef } from "react";
import { useParams,useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getTemplateDetail, submitSingle, getSingleDetail, updateSingle, deleteSingle} from "../../../utils/faqApi";

const ContentTab = ({ isTemplateId,setTemplateId,updateFaqTabData,faqTabData,setRefreshWidgetList }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRefs = useRef([]);
    const [apiProfileList, setApiProfileList] = useState([]);
    const [isSubmitSingle, setIsSubmitSingle] = useState(false); 
    const location = useLocation();
    const isEditPage = location.pathname.startsWith("/customer/edit/faq/");
    const { uuid } = useParams();
    const templateId = isEditPage && uuid ? uuid : isTemplateId || "";
    const [apiSingle, setApiSingle] = useState(null);
    const [singleId, setSingleId] = useState(null);

    //Details
    const [isShowDisplayCategoryTitle, setIsShowDisplayCategoryTitle] = useState(Number(faqTabData.is_show_display_category_title));
    const [widgetTitle, setWidgetTitle] = useState(faqTabData.widget_title);

    //Wrap fetchTemplateDetails in useCallback to prevent re-creation on every render
    const fetchTemplateDetails = useCallback(async () => {
        if (!templateId) return;

        setIsLoading(true);
        try {
            const templateResult = await getTemplateDetail(templateId);
            if (templateResult?.status === true && Array.isArray(templateResult?.data?.data_list)) {
                if (templateResult?.status === true && templateResult?.data?.data_list) {
                    setApiProfileList(templateResult.data.data_list);
                } else {
                    setApiProfileList([]);
                }
            } else {
                setApiProfileList([]);
            }
        } catch (error) {
            //console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [templateId]);

    // Fix useEffect by including fetchTemplateDetails
    useEffect(() => {
        fetchTemplateDetails();
    }, [fetchTemplateDetails]);

    // Toggle dropdown visibility
    const toggleDropdown = (index) => {
        setOpenDropdown((prev) => (prev === index ? null : index));
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                openDropdown !== null &&
                dropdownRefs.current[openDropdown] &&
                !dropdownRefs.current[openDropdown].contains(event.target) &&
                !event.target.closest(".inner-dropdown-menu")
            ) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdown]);

    //Submit Single Handler
    const handleSubmitSingle = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitSingle(true);
            setOpenDropdown(null);

            //Create Payload
            const payload = {
                template_id: templateId,
                id: singleId,
                question: e.target.question?.value || '',
                answer: e.target.answer?.value || ''
            };

            //Api Call
            const response = await submitSingle(payload);
            
            if (response.status === true) { 
                toast.success(response.message);
                
                //Call templat details
                await fetchTemplateDetails();
                setActiveSettingElementsTab("main");
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(response.message);
            } 
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    };

    // Handle Edit Click 
    const handleEditSingle = (data) => {
        setOpenDropdown(null);
        setSingleId(data.id);
        setActiveSettingElementsTab("edit_single");
        fetchSingleDetails(data.id);
    };

    // Handle Delete Click
    const handleDeleteSingle = async (data) => {
        setOpenDropdown(null);

        try {
            // Prepare the payload
            const payload = {
                single_id: data.id,
            };

            // API Call
            const api_response = await deleteSingle(payload);
            // Check API Response
            if (api_response.status === true) {
                toast.success(api_response.message);

                // Refresh testimonials
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    // Wrap fetchSingleDetails in useCallback to prevent re-creation on every render
    const fetchSingleDetails = useCallback(async (singleId) => {
        if (!singleId) return;

        setIsLoading(true); 
        try {
            const templateResult = await getSingleDetail(singleId); 
            if (templateResult?.status === true && templateResult?.data) {
                setApiSingle(templateResult.data);
            } else { 
                setApiSingle(null);
            }
        } catch (error) {
            //console.error("Error fetching:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Also include fetchTemplateDetails in this useEffect
    useEffect(() => {
        if (isEditPage && uuid && !apiSingle) {
            fetchSingleDetails(uuid);
        }
    }, [isEditPage, uuid, apiSingle, fetchSingleDetails]);

    //Update Single Handler
    const handleUpdateSingle = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitSingle(true);
            setOpenDropdown(null);

            //Create Payload
            const payload = {
                id: singleId,
                question: e.target.question?.value || '',
                answer: apiSingle.answer || ''
            };

            //Api Call
            const response = await updateSingle(payload);

            if (response.status) {
                toast.success(response.message);

                //Refresh Logo Showcase
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);

                // Switch back to the main view
                setActiveSettingElementsTab("main");
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    }; 

    //Handlers Show Display Category Title Change
    const handleDisplayCategoryTitleChange = (e) => {
        const checked = e.target.checked;
        setIsShowDisplayCategoryTitle(checked);
        updateFaqTabData("is_show_display_category_title", checked); 
    };

    //Handlers Widget Title Change
    const handleWidgetTitleChange = (e) => {
        const value = e.target.value;
        setWidgetTitle(value);
        updateFaqTabData("widget_title", value); 
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Content</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row ">
                            <span>Display Category Titles</span>
                            <div className="form-group">
                                <input id="open_is_show_category" className="chkbx-toggle" type="checkbox" checked={isShowDisplayCategoryTitle} onChange={handleDisplayCategoryTitleChange} />
                                <label for="open_is_show_category"></label>
                            </div>
                        </div>
                        <div className="box-header-row bubble-text border-0">
                            <span>Widget Title</span>
                            <input name="link" value={widgetTitle} type="text" onChange={handleWidgetTitleChange} />
                        </div>
                    </div>

                    <div className="side-baar-box-header ">
                        <div className="testimonal-side-baar-list faq_list_sidebar">
                            {isLoading ? (
                                <div className="inner-loader-container">
                                    <div className="inner-spinner"></div>
                                    <p>Loading, please wait...</p>
                                </div>
                            ) : apiProfileList?.length > 0 ? (
                                <ul className="">
                                    {apiProfileList.map((data, index) => (
                                        <li key={index} className="testimonal-item">
                                            <button type="button" className="testimonal-item-button" onClick={() => handleEditSingle(data)}>
                                                <div className="list-image-testimonal">
                                                    <p>{data.question}</p>
                                                </div>
                                                <div className="list-text-testimonal">  
                                                    <p>{data.answer}</p>
                                                </div>
                                            </button>
                                            <div className="list-button-testimonal" ref={(el) => (dropdownRefs.current[index] = el)}>
                                                <button onClick={() => toggleDropdown(index)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3.864 8.333a1.363 1.363 0 1 1 0 2.726 1.363 1.363 0 0 1 0-2.726Zm6.136 0a1.363 1.363 0 1 1 .001 2.726A1.363 1.363 0 0 1 10 8.333Zm6.136 0a1.363 1.363 0 1 1 .001 2.726 1.363 1.363 0 0 1 0-2.726Z"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                            {openDropdown === index && (
                                                <div className="inner-dropdown-menu">
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleEditSingle(data)}>Edit</button>
                                                    </div>
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleDeleteSingle(data)}> Delete</button>
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="add-testimonal-button">
                            <button onClick={() => setActiveSettingElementsTab("add_faq")}>+ Add Faq</button>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "add_faq" && (
                <div className="inner-box-layout">
                    <form onSubmit={handleSubmitSingle}>
                        <span>
                            <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                            </button>
                            Add Faq
                        </span>

                        <div className="side-baar-box-header">
                            <div className="box-header-row bubble-text">
                                <label>Question</label>
                                <input name="question" placeholder="Question..." type="text" />
                            </div>
                            <div className="box-header-row bubble-text">
                                <label> Answer</label>
                                <textarea
                                    className="w-100"
                                    name="answer"
                                ></textarea>
                            </div> 
                            <div className="customize-button mb-2"> 
                                <button type="submit" className="float-none text-black bg-white" disabled={isSubmitSingle}>
                                    {isSubmitSingle ? "Submiting..." : "Submit"}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            )}

            {activeSettingElementsTab === "edit_single" && (
                <div className="inner-box-layout">
                    {isLoading ? (
                        <div className="inner-loader-container">
                            <div className="inner-spinner"></div>
                            <p>Loading, please wait...</p>
                        </div>
                    ) : apiSingle ? (
                        <>
                        <form onSubmit={handleUpdateSingle}>
                            <span>
                                <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                                </button>
                                Edit Faq
                            </span>

                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <label>Question</label>
                                    <input name="question" value={apiSingle.question || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, question: e.target.value })} placeholder="Question..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label> Answer</label>
                                    <textarea
                                        className="w-100"
                                        value={apiSingle.answer || ""}
                                        onChange={(e) =>
                                            setApiSingle({ ...apiSingle, answer: e.target.value })
                                        }
                                    />
                                </div>
                                <div className="customize-button mb-2"> 
                                    <button type="submit" className="float-none text-black bg-white" disabled={isSubmitSingle}>
                                        {isSubmitSingle ? "Updating..." : "Update"}
                                    </button>
                                 </div>
                            </div>
                        </form>
                        </>
                    ) : (
                        <p>No single details. Please try again.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ContentTab;